import {
	FETCH_DEP_ETAT_BEGIN,
	FETCH_DEP_ETAT_SUCCESS,
	FETCH_DEP_ETAT_ERROR,
	FETCH_DEP_A_COMPLETER_COUNT_SUCCESS,
	FETCH_DEPTOLOCATION_BEGIN,
	FETCH_DEPTOLOCATION_SUCCESS,
	FETCH_DEPTOLOCATION_ERROR,
	FETCH_DEPANNAGE_BEGIN,
	FETCH_DEPANNAGE_SUCCESS,
	FETCH_DEPANNAGE_ERROR,
	FETCH_DEPANNAGE_RESET,
	POST_DEPANNAGE_BEGIN,
	POST_DEPANNAGE_SUCCESS,
	POST_DEPANNAGE_ERROR,
	POST_DEPANNAGE_ERRORFIELD,
	POST_DEPANNAGE_RESET,
	POST_DEPANNAGE_FULLRESET,
	FETCH_APPELS_BEGIN,
	FETCH_APPELS_SUCCESS,
	FETCH_APPELS_ERROR,
	POST_APPEL_BEGIN,
	POST_APPEL_SUCCESS,
	POST_APPEL_ERROR,
	POST_APPEL_RESET,
	DELETE_APPEL_BEGIN,
	DELETE_APPEL_ERROR,
	DELETE_APPEL_RESET,
	DELETE_APPEL_SUCCESS,
	FETCH_DESTS_BEGIN,
	FETCH_DESTS_SUCCESS,
	FETCH_DESTS_ERROR,
	POST_DESTS_BEGIN,
	POST_DESTS_SUCCESS,
	POST_DESTS_ERROR,
	POST_DESTS_RESET,
	DELETE_DEST_BEGIN,
	DELETE_DEST_SUCCESS,
	DELETE_DEST_ERROR,
	DELETE_DEST_RESET,
	FETCH_DEPVEHICULES_BEGIN,
	FETCH_DEPVEHICULES_SUCCESS,
	FETCH_DEPVEHICULES_ERROR,
	FETCH_DEP_CLIENTVEHICULE_BEGIN,
	FETCH_DEP_CLIENTVEHICULE_SUCCESS,
	FETCH_DEP_CLIENTVEHICULE_ERROR,
	FETCH_DEP_CLIENTVEHICULE_RESET,
	POST_DEP_TO_ATE_BEGIN,
	POST_DEP_TO_ATE_ERROR,
	POST_DEP_TO_ATE_SUCCESS,
	POST_DEP_TO_ATE_RESET,
	POST_DEP_MATERIEL_BEGIN,
	POST_DEP_MATERIEL_ERROR,
	POST_DEP_MATERIEL_RESET,
	POST_DEP_MATERIEL_SUCCESS,
} from "../actions/depannageActions"
import * as Addons from "../../utilities/Addons"
import { getBaseDep } from "../../utilities/defaultObjects"

// INITIAL STATE
const initialState = {
	dep: getBaseDep(),
	// A4 (CDC 16.10) : la fiche telle que reçue du serveur (chargement ou
	// réponse du dernier save), renvoyée en `_charge` à la sauvegarde → le
	// serveur n'écrit que les champs modifiés à l'écran (fusion à 3 voies).
	depCharge: null,
	dests: [],
	depVehicules: [],
	clientVehicule: [],
	fetchClientVehicule: {
		loading: false,
		error: false,
	},
	appels: [],
	from: null,
	fetchAppels: {
		loading: false,
		error: false,
		errorDetails: {},
	},
	fetchDests: {
		loading: false,
		error: false,
		errorDetails: {},
	},
	fetchDepVehicules: {
		loading: false,
		error: false,
		errorDetails: {},
	},
	fetchDep: {
		mustLoad: false,
		id: 0,
		loading: false,
		error: false,
		errorDetails: {},
	},
	postAppel: {
		saved: false,
		saving: false,
		error: false,
		errorFields: [],
	},
	postDepannage: {
		saved: false,
		saving: false,
		error: false,
		errorFields: [],
	},
	postDest: {
		saved: false,
		saving: false,
		error: false,
		errorFields: [],
	},
	deleteDest: {
		deleting: false,
		deleted: false,
		error: false,
	},
	deleteAppel: {
		deleting: false,
		deleted: false,
		error: false,
	},
	depToLocation: {
		clients: [],
		vehicules: [],
	},
	fetchDepToLocation: {
		loading: false,
		error: false,
	},
	postDepToAtelier: {
		saving: false,
		saved: false,
		error: false,
	},
	postDepMateriel: {
		saved: false,
		saving: false,
		error: false,
	},
	atelierQuittance: {},
	// GE-46 : page /depannage/etat (données du menu courant) + badge nav.
	depEtat: {
		menu: null,
		data: null,
		loading: false,
		error: false,
	},
	depACompleterCount: 0,
}

// STORE MODIFIERS
export default function depannageReducer(state = initialState, action) {
	let nextState
	switch (action.type) {
		// FETCH DEPTOLOCATION
		case FETCH_DEPTOLOCATION_BEGIN:
			return {
				...state,
				fetchDepToLocation: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DEPTOLOCATION_SUCCESS:
			return {
				...state,
				fetchDepToLocation: {
					loading: false,
				},
				depToLocation: action.payload.depToLocation,
			}
		case FETCH_DEPTOLOCATION_ERROR:
			return {
				...state,
				fetchDepToLocation: {
					loading: false,
					error: true,
					errorDetails: action.payload,
				},
			}
		case FETCH_APPELS_BEGIN:
			return {
				...state,
				fetchAppels: {
					loading: true,
					error: null,
				},
			}
		case FETCH_APPELS_SUCCESS:
			return {
				...state,
				fetchAppels: {
					loading: false,
				},
				appels: action.payload.appels,
			}
		case FETCH_APPELS_ERROR:
			return {
				...state,
				fetchAppels: {
					loading: false,
					error: true,
					errorDetails: action.payload,
				},
			}
		// POST APPEL
		case POST_APPEL_BEGIN:
			return {
				...state,
				postAppel: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_APPEL_ERROR:
			return {
				...state,
				postAppel: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_APPEL_SUCCESS:
			return {
				...state,
				appels: action.payload.appels,
				postAppel: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_APPEL_RESET:
			return {
				...state,
				postAppel: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE APPEL
		case DELETE_APPEL_BEGIN:
			return {
				...state,
				deleteAppel: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_APPEL_ERROR:
			return {
				...state,
				deleteAppel: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_APPEL_SUCCESS:
			return {
				...state,
				appels: action.payload.appels,
				deleteAppel: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_APPEL_RESET:
			return {
				...state,
				deleteAppel: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH DESTS
		case FETCH_DESTS_BEGIN:
			return {
				...state,
				fetchDests: {
					loading: true,
					error: null,
				},
			}
		case FETCH_DESTS_SUCCESS:
			return {
				...state,
				fetchDests: {
					loading: false,
				},
				dests: action.payload.dests,
			}
		case FETCH_DESTS_ERROR:
			return {
				...state,
				fetchDests: {
					loading: false,
					error: true,
					errorDetails: action.payload,
				},
			}
		// POST DESTS
		case POST_DESTS_BEGIN:
			return {
				...state,
				postDest: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_DESTS_ERROR:
			return {
				...state,
				postDest: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_DESTS_SUCCESS:
			return {
				...state,
				dests: action.payload.dests,
				postDest: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_DESTS_RESET:
			return {
				...state,
				postDest: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE DESTS
		case DELETE_DEST_BEGIN:
			return {
				...state,
				deleteDest: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_DEST_ERROR:
			return {
				...state,
				deleteDest: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_DEST_SUCCESS:
			return {
				...state,
				dests: action.payload.dests,
				deleteDest: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_DEST_RESET:
			return {
				...state,
				deleteDest: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// FETCH DEPVEHICULES
		case FETCH_DEPVEHICULES_BEGIN:
			return {
				...state,
				fetchDepVehicules: {
					loading: true,
					error: null,
				},
			}
		case FETCH_DEPVEHICULES_SUCCESS:
			return {
				...state,
				fetchDepVehicules: {
					loading: false,
				},
				depVehicules: action.payload.depVehicules,
			}
		case FETCH_DEPVEHICULES_ERROR:
			return {
				...state,
				fetchDepVehicules: {
					loading: false,
					error: true,
					errorDetails: action.payload,
				},
			}
		// FETCH DEPANNAGE
		case FETCH_DEPANNAGE_BEGIN:
			return {
				...state,
				fetchDep: {
					loading: true,
					error: false,
					errorDetails: {},
				},
			}
		case FETCH_DEPANNAGE_SUCCESS:
			let tempDep = action.payload.depannage[0]
			const fetchCharge = JSON.parse(JSON.stringify(tempDep))
			tempDep.livraisons.forEach((liv) => {
				if (liv.destination_adresse === null) {
					liv.destination_adresse = {
						id: Math.random(),
						ligne_0: "",
						ligne_1: "",
						ligne_2: "",
						type: 0,
						isParc: false,
					}
				}
			})
			return {
				...state,
				dep: tempDep,
				depCharge: fetchCharge,
				fetchDep: {
					loading: false,
					error: false,
					errorDetails: {},
				},
			}
		case FETCH_DEPANNAGE_ERROR:
			return {
				...state,
				fetchDep: {
					loading: false,
					error: true,
					errorDetails: action.payload.error,
				},
			}
		case FETCH_DEPANNAGE_RESET:
			return {
				...state,
				dep: getBaseDep(),
				depCharge: null,
				fetchDep: {
					loading: false,
					error: false,
					errorDetails: {},
				},
			}
		// POST DEPANNAGE
		case POST_DEPANNAGE_BEGIN:
			return {
				...state,
				postDepannage: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_DEPANNAGE_ERROR:
			return {
				...state,
				postDepannage: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_DEPANNAGE_ERRORFIELD:
			let errorFields = action.payload.errorFields
			nextState = {
				...state,
				postDepannage: {
					saved: false,
					saving: false,
					error: false,
					errorFields,
				},
			}
			return nextState
		case POST_DEPANNAGE_SUCCESS:
			let postDep = action.payload.depannage[0]
			const postCharge = JSON.parse(JSON.stringify(postDep))
			postDep.livraisons.forEach((liv) => {
				if (liv.destination_adresse === null) {
					liv.destination_adresse = {
						id: Math.random(),
						ligne_0: "",
						ligne_1: "",
						ligne_2: "",
						type: 0,
						isParc: false,
					}
				}
			})
			return {
				...state,
				dep: postDep,
				depCharge: postCharge,
				postDepannage: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_DEPANNAGE_RESET:
			return {
				...state,
				postDepannage: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_DEPANNAGE_FULLRESET:
			return {
				...state,
				dep: getBaseDep(),
				depCharge: null,
				postDepannage: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// POST_DEP_TO_ATE
		case POST_DEP_TO_ATE_BEGIN:
			return {
				...state,
				postDepToAtelier: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_DEP_TO_ATE_ERROR:
			return {
				...state,
				postDepToAtelier: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_DEP_TO_ATE_SUCCESS:
			return {
				...state,
				dep: {
					...state.dep,
					atelier: action.payload.data.data.ate,
					nom: action.payload.data.data.nom,
					prenom: action.payload.data.data.prenom,
					tel: action.payload.data.data.tel,
					plaques: action.payload.data.data.plaques,
					marque: action.payload.data.data.marque,
					modele: action.payload.data.data.modele,
				},
				postDepToAtelier: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_DEP_TO_ATE_RESET:
			return {
				...state,
				postDepToAtelier: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// POST_DEP_MATERIEL
		case POST_DEP_MATERIEL_BEGIN:
			return {
				...state,
				postDepMateriel: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_DEP_MATERIEL_ERROR:
			return {
				...state,
				postDepMateriel: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_DEP_MATERIEL_SUCCESS:
			return {
				...state,
				atelierInfo: action.payload.data.data.atelierInfo,
				dep: {
					...state.dep,
					atelier: action.payload.data.data.ate,
					nom: action.payload.data.data.nom,
					prenom: action.payload.data.data.prenom,
					tel: action.payload.data.data.tel,
					plaques: action.payload.data.data.plaques,
					marque: action.payload.data.data.marque,
					modele: action.payload.data.data.modele,
				},
				postDepMateriel: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_DEP_MATERIEL_RESET:
			return {
				...state,
				postDepMateriel: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// STORE MODIFIER ONCLICK ONCHANGE
		case "SET_DEP":
			nextState = {
				...state,
				dep: action.value,
			}
			return nextState
		case "SET_APPEL":
			const appelIndex = state.appels.findIndex(
				(appel) => appel.id === action.value.id,
			)
			if (appelIndex !== -1) {
				let tempappels = [
					...state.appels.slice(0, appelIndex),
					action.value,
					...state.appels.slice(appelIndex + 1),
				]
				nextState = {
					...state,
					appels: tempappels,
				}
			} else {
				nextState = {
					...state,
					appels: [...state.appels, action.value],
				}
			}
			return nextState
		case "SET_DEPVEHICULE":
			const depVehiculeIndex = state.depVehicules.findIndex(
				(depVehicule) => depVehicule.id === action.value.id,
			)
			if (depVehiculeIndex !== -1) {
				let tempdepVehicules = [
					...state.depVehicules.slice(0, depVehiculeIndex),
					action.value,
					...state.depVehicules.slice(depVehiculeIndex + 1),
				]
				nextState = {
					...state,
					depVehicules: tempdepVehicules,
				}
			} else {
				nextState = {
					...state,
					depVehicules: [...state.depVehicules, action.value],
				}
			}
			return nextState
		case "REMOVE_DEPVEHICULE":
			return {
				...state,
				depVehicules: state.depVehicules.filter(
					(dv) => dv.id !== action.value,
				),
			}
		case "REMOVE_APPELASSU":
			nextState = {
				...state,
				appels: state.appels.filter(
					(appel) => appel.id !== action.value,
				),
			}
			return nextState
		case "SET_APPELASSU":
			const AAappel = state.appels[action.appelIndex]
			const appelAssuIndex = AAappel.assu.findIndex(
				(appelAssu) => appelAssu.id === action.value.id,
			)
			if (appelAssuIndex !== -1) {
				let tempAppelAssu = [
					...state.appels[action.appelIndex].assu.slice(
						0,
						appelAssuIndex,
					),
					action.value,
					...state.appels[action.appelIndex].assu.slice(
						appelAssuIndex + 1,
					),
				]
				AAappel.assu = tempAppelAssu
				nextState = {
					...state,
					appels: [
						...state.appels.slice(0, action.appelIndex),
						AAappel,
						...state.appels.slice(action.appelIndex + 1),
					],
				}
				return nextState
			} else {
				AAappel.assu.push(action.value)
				nextState = {
					...state,
					appels: [
						...state.appels.slice(0, action.appelIndex),
						AAappel,
						...state.appels.slice(action.appelIndex + 1),
					],
				}
			}
			return nextState
		//////
		/////
		case "REMOVE_LIVRAISON":
			nextState = {
				...state,
				dep: {
					...state.dep,
					livraisons: state.dep.livraisons.filter(
						(livraison) => livraison.id !== action.value,
					),
				},
			}
			return nextState
		case "SET_LIVRAISON":
			const livraisonIndex = state.dep.livraisons.findIndex(
				(livraison) => livraison.id === action.value.id,
			)
			if (livraisonIndex !== -1) {
				let tempLivraisons = [
					...state.dep.livraisons.slice(0, livraisonIndex),
					action.value,
					...state.dep.livraisons.slice(livraisonIndex + 1),
				]
				nextState = {
					...state,
					dep: {
						...state.dep,
						livraisons: tempLivraisons,
					},
				}
				return nextState
			} else {
				nextState = {
					...state,
					dep: {
						...state.dep,
						livraisons: [...state.dep.livraisons, action.value],
					},
				}
				return nextState
			}
		/////
		case "SET_DEST":
			const destIndex = state.dests.findIndex(
				(dest) => dest.id === action.value.id,
			)
			if (destIndex !== -1) {
				let tempDests = [
					...state.dests.slice(0, destIndex),
					action.value,
					...state.dests.slice(destIndex + 1),
				]
				nextState = {
					...state,
					dests: tempDests,
				}
				return nextState
			} else {
				nextState = {
					...state,
					dests: [...state.dests, action.value],
				}
				return nextState
			}
		case "REMOVE_DEST":
			return {
				...state,
				dests: state.dests.filter((dest) => dest.id !== action.value),
			}
		/////
		case "REMOVE_NOTE":
			nextState = {
				...state,
				dep: {
					...state.dep,
					notes: state.dep.notes.filter(
						(note) => note.id !== action.value,
					),
					// Le serveur ne supprime QUE les notes listées ici, jamais
					// une note absente du payload (écrite par SvpCentral ou le
					// serveur pendant que la fiche est ouverte). Note neuve
					// (id provisoire non entier) : rien à supprimer en base.
					notes_supprimees: Number.isInteger(action.value)
						? [...(state.dep.notes_supprimees || []), action.value]
						: state.dep.notes_supprimees || [],
				},
			}
			return nextState
		case "SET_NOTE":
			const noteIndex = state.dep.notes.findIndex(
				(note) => note.id === action.value.id,
			)
			if (noteIndex !== -1) {
				let tempNotes = [
					...state.dep.notes.slice(0, noteIndex),
					action.value,
					...state.dep.notes.slice(noteIndex + 1),
				]
				nextState = {
					...state,
					dep: {
						...state.dep,
						notes: tempNotes,
					},
				}
				return nextState
			} else {
				nextState = {
					...state,
					dep: {
						...state.dep,
						notes: [...state.dep.notes, action.value],
					},
				}
				return nextState
			}
		/////
		case "SET_FOURNITURE": {
			// Fourniture terrain (AtelierLigne de la fiche) mise à jour par id.
			const fournitures = [...(state.dep.atelierLignes || [])]
			const fIndex = fournitures.findIndex(
				(l) => l.id === action.value.id,
			)
			if (fIndex === -1) return state
			fournitures[fIndex] = action.value
			return {
				...state,
				dep: { ...state.dep, atelierLignes: fournitures },
			}
		}
		case "REMOVE_AUTRE":
			nextState = {
				...state,
				dep: {
					...state.dep,
					autres: state.dep.autres.filter(
						(autre) => autre.id !== action.value,
					),
				},
			}
			return nextState
		case "SET_AUTRE":
			const autreIndex = state.dep.autres.findIndex(
				(autre) => autre.id === action.value.id,
			)
			if (autreIndex !== -1) {
				let tempAutres = [
					...state.dep.autres.slice(0, autreIndex),
					action.value,
					...state.dep.autres.slice(autreIndex + 1),
				]
				nextState = {
					...state,
					dep: {
						...state.dep,
						autres: tempAutres,
					},
				}
				return nextState
			} else {
				nextState = {
					...state,
					dep: {
						...state.dep,
						autres: [...state.dep.autres, action.value],
					},
				}
				return nextState
			}
		case "SET_DEP_FROM":
			return {
				...state,
				from: action.value,
			}
		case FETCH_DEP_CLIENTVEHICULE_BEGIN:
			return {
				...state,
				fetchClientVehicule: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DEP_CLIENTVEHICULE_ERROR:
			return {
				...state,
				fetchClientVehicule: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_DEP_CLIENTVEHICULE_RESET:
			return {
				...state,
				clientVehicule: [],
				fetchClientVehicule: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DEP_CLIENTVEHICULE_SUCCESS:
			let cvs = []
			for (let cl of action.payload.clientVehicule) {
				for (let cv of cl.clientVehicules) {
					cvs.push({
						id: cl.id,
						nom: cl.nom,
						prenom: cl.prenom,
						tel: cl.tel,
						adresse: cl.adresse,
						adresse2: cl.adresse2,
						plaques: cv.plaques,
						marque: cv.marque,
						modele: cv.modele,
						vehId: cv.id,
					})
				}
			}
			return {
				...state,
				clientVehicule: cvs,
				fetchClientVehicule: {
					loading: false,
					error: false,
				},
			}
		case "REORDER_DESTS":
			let dragIndex = state.dests.findIndex(
				(dest) => dest.id === action.dragId,
			)
			let dropIndex = state.dests.findIndex(
				(dest) => dest.id === action.dropId,
			)
			if (dragIndex < dropIndex) {
				return {
					...state,
					dests: [
						...state.dests.slice(0, dragIndex),
						...state.dests.slice(dragIndex + 1, dropIndex + 1),
						state.dests[dragIndex],
						...state.dests.slice(dropIndex + 1),
					],
				}
			} else if (dragIndex > dropIndex) {
				return {
					...state,
					dests: [
						...state.dests.slice(0, dropIndex),
						state.dests[dragIndex],
						...state.dests.slice(dropIndex, dragIndex),
						...state.dests.slice(dragIndex + 1),
					],
				}
			} else {
				return {
					...state,
				}
			}
		case FETCH_DEP_ETAT_BEGIN:
			return {
				...state,
				depEtat: {
					// Données gardées si on recharge le même menu (pas de flash).
					data:
						state.depEtat.menu === action.payload.menu
							? state.depEtat.data
							: null,
					menu: action.payload.menu,
					loading: true,
					error: false,
				},
			}
		case FETCH_DEP_ETAT_SUCCESS:
			return {
				...state,
				depEtat: {
					menu: action.payload.menu,
					data: action.payload.data,
					loading: false,
					error: false,
				},
			}
		case FETCH_DEP_ETAT_ERROR:
			return {
				...state,
				depEtat: {
					...state.depEtat,
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_DEP_A_COMPLETER_COUNT_SUCCESS:
			return { ...state, depACompleterCount: action.payload }
		default:
			return state
	}
}
